<template>
    <div class="fourthTest">
        <img class="third-tree animationLeftRight pos" src="http://wwj.jijiagames.com/web/act/20190702/third_tree.png" alt="">
        <img class="fourth-bird pos" src="../assets/img/fourth_bird.png" alt="">
        <img class="fourth-tree animationLeftRight pos" src="http://wwj.jijiagames.com/web/act/20190702/fourth_tree.png" alt="">
        <img class="fourth pos animationUpDown" src="../assets/img/fourth.png" alt="">
        <img class="second-xianrenz animationLeftRight pos" src="../assets/img/second_xianrenz.png" alt="">
        <img class="fourth-cao2 animationLeftRight pos" src="../assets/img/fourth_cao2.png" alt="">
        <img class="third-ye pos" src="../assets/img/third_ye.png" alt="">
        <img class="fourth-wind-shu pos" src="../assets/img/fourth_wind_shu.png" alt="">
        <img class="fourth-wind-ye pos" src="../assets/img/fourth_wind_ye.png" alt="">
        <img class="fourth-yellow pos" src="../assets/img/fourth_yellow.png" alt="">
        <!-- <img class="fourth-wind-kuang pos" src="../assets/img/fourth_wind_kuang.png" alt=""> -->
    </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.fourthTest
    .third-tree
        top 0
        left -3.5rem
    .fourth-bird
        top 14%
        left 2rem
    .fourth-tree
        top 0
        right -3.4rem
    .fourth
        width 37%
        bottom 0.3rem
        right 0.6rem
        z-index 111
    .second-xianrenz
        bottom 0
        right -1.5rem
    .fourth-cao2
        bottom 0
        right -2.8rem
        z-index 111
    .third-ye
        bottom 0
        left -2.6rem
    .fourth-wind-shu
        bottom 0.4rem
        left 1.1rem
    .fourth-wind-ye
        bottom 1.6rem
        left 0.2rem
        animation rotate 4s linear infinite
    .fourth-yellow
        width 20%
        bottom 0
        right 0.8rem
@keyframes rotate
    0%
        transform rotate(0deg)
    25%
        transform rotate(90deg)
    50%
        transform rotate(180deg)
    75%
        transform rotate(270deg)
    100%
        transform rotate(360deg)
</style>
